import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel('1726337018738596');
    trackPageView();
  }, []);
  return <LandingPage data-id="element-0" />;
}